<mat-button-toggle-group *ngIf="settings?.buttons.length">
  <span *ngFor="let btn of settings.buttons" [wlmInterceptClick]="[btn.key, btn.beforeToggle]">
    <mat-button-toggle [value]="btn.key" (click)="onToggle($event, btn)">
      {{ btn.labelKey | translate }}
    </mat-button-toggle>
  </span>
</mat-button-toggle-group>
